export default __webpack_public_path__ + "static/media/reapp.9fdd7cba.svg";